<template>
  <section>
    <div class="big-card" v-if="type == 'proCard'" @click="cardDetail">
      <el-image lazy :src="card.proImg" v-if="card.proImg" fit="cover">
        <div slot="placeholder" class="image-slot">
          <img
            src="data:image/png;base64,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"
          />
        </div>
      </el-image>
      <div class="big-card-desc">
        <div class="big-card-title">{{ card.proName }}</div>
        <div class="big-card-text-1line">{{ card.proMsg }}</div>
        <div class="big-card-ctrl">
          <div class="big-card-btn">
            <span>查看详情</span>
            <img src="../assets/img/nxt.png" alt />
          </div>
        </div>
      </div>
    </div>

    <div class="big-card" v-if="type == 'cropCard'" @click="cardDetail">
      <el-image lazy :src="card.img" v-if="card.img" fit="cover">
        <div slot="placeholder" class="image-slot">
          <img
            src="data:image/png;base64,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"
          />
        </div>
      </el-image>
      <div class="big-card-desc">
        <div class="big-card-title">{{ card.name }}</div>
        <div class="big-card-text-1line">
          {{`${card.name}`}}
        </div>
        <div class="big-card-ctrl">
          <div class="big-card-btn">
            <span>查看详情</span>
            <img src="../assets/img/nxt.png" alt />
          </div>
          <div class="big-card-ctrl-rt">
            <div class="card-ctrl-item">
              <span class="iconfont icon-chakan"></span>
              <span>{{ card.num }}</span>
            </div>
            <div class="card-ctrl-item">
              <span class="iconfont icon-zuozhe"></span>
              <span>{{ card.userName | nameNoPhone }}</span>
            </div>
            <div class="card-ctrl-item">
              <span class="iconfont icon-shijian"></span>
              <span>{{ card.createTime | timeAgo }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="big-card" v-if="type == 'askCard'" @click="cardDetail">
      <img
        :src="card.askImgEntities[0].img"
        class="el-image"
        v-if="card.askImgEntities.length > 0"
        alt
      />
      <div class="big-card-desc">
        <div class="big-card-title">{{ card.message }}</div>
        <div class="big-card-text-1line"></div>
        <div class="big-card-ctrl">
          <div class="big-card-btn">
            <span>查看详情</span>
            <img src="../assets/img/nxt.png" alt />
          </div>
          <div class="big-card-ctrl-rt">
            <div class="card-ctrl-item">
              <span class="iconfont icon-chakan"></span>
              <span>{{ card.clickViews | upTo5 }}</span>
            </div>
            <div class="card-ctrl-item">
              <span class="iconfont icon-zuozhe"></span>
              <span>{{ card.userName | nameNoPhone }}</span>
            </div>
            <div class="card-ctrl-item">
              <span class="iconfont icon-shijian"></span>
              <span>{{ card.createDate | timeAgo }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="big-card" v-if="type == 'researchCard'" @click="cardDetail">
      <el-image
        lazy
        :src="
        !card.researchImgEntities||card.researchImgEntities.length==0?'':
          card.researchImgEntities[0].coverImg ||
          card.researchImgEntities[0].img
        "
        v-if="!!card.researchImgEntities&&card.researchImgEntities.length > 0"
        fit="cover"
      >
        <div slot="placeholder" class="image-slot">
          <img
            src="data:image/png;base64,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"
          />
        </div>
      </el-image>
      <div class="big-card-desc">
        <div class="big-card-title">{{ card.subject }}</div>
        <div class="big-card-text-1line">{{ card.content | htmlToText }}</div>
        <div class="big-card-ctrl">
          <div class="big-card-btn">
            <span>查看详情</span>
            <img src="../assets/img/nxt.png" alt />
          </div>
          <div class="big-card-ctrl-rt">
            <div class="card-ctrl-item">
              <span class="iconfont icon-chakan"></span>
              <span>{{ card.clickViews | upTo5 }}</span>
            </div>
            <div class="card-ctrl-item">
              <span class="iconfont icon-zuozhe"></span>
              <span>{{ card.name }}</span>
            </div>
            <div class="card-ctrl-item">
              <span class="iconfont icon-shijian"></span>
              <span>{{ card.createTime | timeAgo }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="big-card" v-if="type == 'activeCard'" @click="cardDetail">
      <el-image
        lazy
        :src="card.img"
        v-if="card.img"
        class="active"
        fit="contain"
      >
        <div slot="placeholder" class="image-slot">
          <img
            src="data:image/png;base64,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"
          />
        </div>
      </el-image>
      <div class="big-card-desc">
        <div class="big-card-title">
          <span class="ing" v-if="card.del == 0">【活动进行中】</span>
          <span class="end" v-else>【活动已结束】</span>
          {{ card.subject }}
        </div>
        <div class="big-card-text-1line">{{ card.htmlContent }}</div>
        <div class="big-card-ctrl">
          <div></div>
          <div class="big-card-ctrl-rt">
            <div class="card-ctrl-item">
              <span class="iconfont icon-chakan"></span>
              <span>{{ card.clickViews | upTo5 }}</span>
            </div>
            <div class="card-ctrl-item">
              <span class="iconfont icon-zuozhe"></span>
              <span>{{ card.clickViews | upTo5 }}</span>
            </div>
            <div class="card-ctrl-item">
              <span class="iconfont icon-shijian"></span>
              <span>{{ card.createTime | timeAgo }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
    },
    card: {
      type: Object,
      required: true,
    },
  },
  methods: {
    cardDetail() {
      this.$emit("cardDetail", this.card);
    },
  },
  filters: {
    nameNoPhone(nickName) {
      if (!nickName) {
        return nickName;
      } else {
        nickName = nickName.replace(/\d{11}/gi, "***");
        return nickName;
      }
    },
    upTo5(num) {
      num = parseInt((num - 0) * 5);
      if (num - 10000 > 0) {
        num = parseInt(num / 10000) + "w+";
      }
      return num;
    },
    timeAgo(time) {
      let between = Date.now() / 1000 - new Date(time).getTime() / 1000;
      if (between < 0) {
        between += 25200;
      }
      if (between < 3600) {
        return `${~~(between / 60)} 分钟前`;
      } else if (between < 86400) {
        return `${~~(between / 3600)} 小时前`;
      } else {
        return `${time.split(" ")[0]}`;
      }
    },
    htmlToText(con) {
      if (!con) {
        return con;
      } else {
        let msg = con.replace(/<style>[\s\S]*?<\/style>/gi, ""); //去除HTML Tag
        msg = msg.replace(/<\/?[^>]*>/g, "");
        msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
        msg = msg.replace(/&nbsp;/gi, "");
        return msg;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.big-card {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  border: 1px solid #e6e6e6;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  // box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  .ing {
    color: #ea0000;
    margin-right: 5px;
  }
  .end {
    color: #999;
    margin-right: 5px;
  }
  &:hover {
    transition: all 0.2s ease-in-out;
    border-color: #65b825;
  }
  .el-image {
    width: 88px;
    height: 88px;
    margin-right: 16px;
    &.active {
      width: 188px;
      height: 88px;
    }
  }
  .big-card-ctrl {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .big-card-ctrl-rt {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .card-ctrl-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        color: #999;
        font-size: 14px;
        margin-left: 8px;
        line-height: 22px;
        .iconfont {
          color: #999;
          font-size: 16px;
          margin-right: 4px;
        }
      }
    }
  }
  .big-card-desc {
    width: 100px;
    flex-grow: 1;
    padding: 5px 0 0 0;
    .big-card-text {
      font-size: 14px;
      color: #666;
      line-height: 22px;
      height: 44px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin-bottom: 10px;
    }
    .big-card-title {
      font-size: 16px;
      max-height: 24px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333;
      font-weight: bold;
    }
    .big-card-text-1line {
      font-size: 14px;
      color: #666;
      line-height: 22px;
      height: 22px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      margin-bottom: 10px;
    }
    .big-card-btn {
      width: 90px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      line-height: 24px;
      border-radius: 24px;
      border: 1px solid #e6e6e6;
      color: #999999;
      img {
        width: 12px;
        height: 12px;
        margin-left: 4px;
        display: block;
      }
    }
  }
}
.image-slot img {
  width: 88px;
  height: 88px;
  display: block;
}
</style>
